// Шарится между IncomingCallSheet/ChatHeader (grab) и CallPage (consume).
// Не Redux чтобы не сериализовать MediaStream.
let pendingStream: MediaStream | null = null;

export function setPreGrabbedStream(stream: MediaStream | null): void {
  pendingStream = stream;
}

export function takePreGrabbedStream(): MediaStream | null {
  const s = pendingStream;
  pendingStream = null;
  return s;
}
